export default function Plus() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 62 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M53.3379 0.5C57.48 0.5 60.8379 3.85786 60.8379 8V56C60.8379 60.1421 57.48 63.5 53.3379 63.5H0.540039V0.5H53.3379Z'
        fill='#F4F4F4'
      />
      <path
        d='M53.3379 0.5C57.48 0.5 60.8379 3.85786 60.8379 8V56C60.8379 60.1421 57.48 63.5 53.3379 63.5H0.540039V0.5H53.3379Z'
        stroke='#EBEDF3'
      />
      <path
        d='M21.04 32H41.54'
        stroke='#222222'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M31.2949 21.7559L31.2949 42.2559'
        stroke='#222222'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
